

import { defineComponent, ref, onMounted, computed,watch } from 'vue';
import { Container } from 'inversify';
import HelperLoading from '@ilinium/shared/src/common/infrastructure/funciones/HelperLoading';
import { TYPES } from '@ilinium/shared/src/common/domain/types';
import { IapDataSourceLookUp } from '../../../datasource/domain/iapDataSourceLookUp';
import { IServiceSearch } from '@ilinium/shared/src/entidades/builder/search/application/IServiceSearch';
import ControlTypeConst from '../../../form/domain/Constants/ControlTypeConst';
import { DropdownChangeEvent } from 'primevue/dropdown';
import DataSourceConst from '../functions/dataSourceConst';
import LookUpSearchTable from './LookUpSearchTable.vue';
import { SearchData } from '../../../search/domain/search';
import { IapCatalog } from '../../../catalog/domain/iapCatalog';

export default defineComponent({
    name: 'lookupeditor',
    components: {
        LookUpSearchTable
    },
    events: ['update:modelValue', 'change:SelectedLookUpData','view:Details'],
    props: {
        container: {
            type: Object as () => Container
        },
        modelValue: {           
            default: () => ({})
        },
        controlWidth: {

            type: String,
            default: ('100%')
        },
        filterConditions: {
            type: Object as () => SearchData[],
            default: []
        },
        dataSourceLookUp: {
            type: Object as () => IapDataSourceLookUp,
            default: []
        },
        lookUpDesc: {
            type: String,
            default:''
        },
        hasDetail: {
            type: Boolean,
            default: false
        },
        hasCommand: {
            type: Boolean,
            default: false
        },
        catalogsData: {
            type: Object as () => IapCatalog[],
            default: () => ([])
        },
        dialogWidth: {
        type: String,
        default: ('50')
        }   

    },
    setup(props, { emit }) {

        const data = ref([])
        const searchTableVisible = ref(false);
        const colSize=ref();
        const actionDialog=ref('');


        const dataModelValue = computed({
            get: () => props.modelValue,
            set: (val) => emit('update:modelValue', val),
        });

        const looKUpDescription = ref();


        watch(actionDialog, (value: any) => {
            setTimeout(function() {
                setColSize();
            }, 50);
            
        });


        const fillDataSource = (applicationId: number, applicationVersion: number, dataSourceLookUpId: number) => {

            if (props.container && applicationId && applicationVersion && dataSourceLookUpId) {
                const _srv = props.container.get<IServiceSearch>(
                    TYPES.SEARCH_REPOSITORY
                );
                HelperLoading.showLoading();
                _srv.searchLookUp(applicationId, applicationVersion,
                    dataSourceLookUpId, props.filterConditions, props.dataSourceLookUp?.maxRowsReturned ?? 5)
                    .then((response) => {

                        data.value = JSON.parse(response?.items ?? '[]');

                    })
                    .catch((err) => {

                    })
                    .finally(() => {

                        HelperLoading.hideLoading();
                    });

            }

        }


        const changeData = (event: DropdownChangeEvent) => {
            emit('change:SelectedLookUpData', data.value.find((x: any) => x[DataSourceConst.LOOKUPID] == event.value))
        }


        const onRowSelected = (event: any) => {
            
            dataModelValue.value = event.data.LookUpId;
            looKUpDescription.value=event.data.LookUpDescription;
            emit('change:SelectedLookUpData', event.data);
            searchTableVisible.value = false;

        };


        const setColSize = () => {
            
            const element = document.getElementById('dialog');
            let col:number=12;

            if(element){
                const elementWidth: number = element.offsetWidth;
                
                if(elementWidth>641 && elementWidth<=1007){
                    col=6;
                }
                else if(elementWidth>1007 && elementWidth<=1200){
                    col=4;
                }
                else if(elementWidth>1200){
                    col=3;
                }
             
            }

            colSize.value=col;
            
        }

        const changeActionValue = (action:string)=>{
              actionDialog.value=action;
        }

   

        onMounted(() => {            
            looKUpDescription.value=props.lookUpDesc;
            if (props.dataSourceLookUp.idControlType !== ControlTypeConst.CTSEARCH){
                fillDataSource(props.dataSourceLookUp.dataSource.applicationId ?? 0, props.dataSourceLookUp?.dataSource.applicationVersion ?? 0, props.dataSourceLookUp.id);            
            }      
            
        })



        return {
            ControlTypeConst,
            DataSourceConst,
            data,
            dataModelValue,
            changeData,
            searchTableVisible,
            onRowSelected,
            looKUpDescription,
            setColSize,
            colSize,
            changeActionValue
            
            
        };
    },
});
